export default {
  start: 'Start',
  end: 'End',
  vacation: {
    title: 'Request leave',
    text: 'Please, choose a days of your vocation, that regional manager will consider request.',
    vacation_requested: 'Vacation is requested',
  },
  holidays: {
    title: 'Add new holiday',
    name: 'Holiday name',
    delete: 'Do you want to delete this holiday from the system?',
  },
  manager_assigned: 'Route successfully created',
  edit_route: 'Route successfully edited',
  success_created: 'Employee successfully created',
  confirm_leave_request: 'Do you want to confirm leave request?',
  reject_leave_reject: 'Do you wnat to reject leave reject?',
  request_confirmed: 'Request is confirmed',
  request_rejected: 'Request is rejected',
  tell_reject_leave: 'Please, tell a reason of reject a leave request',
  select_employee: 'Select employee and period',
  days: 'days',
  for: 'For',
  from: 'From',
  to: 'to',
  approved: 'Approved',
  mileage_planned: 'The actual mileage differs from the planned',
  mileage_planned_text:
    'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
  planned: 'planned',
  actual: 'actual',
  delete_route_text: 'Do you want to delete route from system?',
  not_working_day: 'Mark as not working day',
  start_work_log: 'Start new work log',
  end_work_log: 'End work log',
  edit_work_log: 'Edit work log',
  work_log_details: 'Worklog details',
  pause_start: 'Pause Start',
  pause_end: 'Pause End',
  days_error: 'Start date cannot be bigger than End date',
  date_range: 'Date range',
  scope_day: 'This day only',
  scope_group: 'Whole absence ({count} days, {start} – {end})',
  confirm_cancel_group:
    'Cancel the whole absence — {count} days, {start} – {end}?',
  work_end: 'Work End',
  choose_type: 'Choose type',
  route: 'Route',
  address: 'Address',
  choose_route: 'Choose route',
  custom: 'Custom',
  km_start: 'private kilometers',
  start_date: 'Start Date',
  end_date: 'End Date',
  start_date_placeholder: 'Choose start date',
  pause_start_placeholder: 'Choose pause start',
  pause_end_placeholder: 'Choose pause end',
  work_end_placeholder: 'Choose work end',
  no_end_date: 'no end date',
  time: 'Time',
  worklog: 'Worklog',
  worklog_placeholder: 'Enter Worklog',
  kilometer_start: 'Kilometer Start',
  kilometer_start_placeholder: 'Enter Kilometer Start',
  kilometer_end: 'Kilometer End',
  kilometer_end_placeholder: 'Enter Kilometer End',
  add_route: 'Add Route',
  add_address: 'Add Address',
  licence_plate: 'Licence plate',
  licence_plate_placeholder: 'Choose licence plate',
  amount_km: 'Amount of kilometers',
  mileage_exceeded: 'Travel mileage exceeded',
  mileage_exceeded_text:
    'Please, write a reason of mileage exceeded or additional deviation',
  privately_driven_km: 'Private kilometers',
  privately_driven_km_placeholder: 'Enter km',
  travel_mileage_exceeded: 'Travel mileage exceeded',
  documented_at: 'documented {date}',

  delete_worklog: {
    do_you_want_to_delete: 'Do you want to delete work log?',
    info: '{name} - from {date}',
    give_reason: 'Please, give a reason for work log deletion',
    deleted: 'Work log deleted',
  },

  work_times_type: {
    normal: {
      title: 'Normal work times',
      text: 'Choose working days and times individually',
    },
    rolling: {
      title: 'Rolling work times',
      text: 'Schedule of 4 days work 2 days off',
    },
  },

  delete_km_log_text: 'Do you want to delete Kilometer Log from system?',
}
